import React, { useState } from 'react';
import { setDeviceDisplayMode } from 'redux/actions';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import {
  reactTableSortOnClickInFuncComp,
  deviceToProductTypeDisplayString,
  getDeviceSwVersion,
  getLowestSwVersion,
  toggleDisplayNameForDevices,
  toggleDisplayNameForBundles
} from 'common/utils/helpers';
import { getGa2DeviceMembers, isGa2Device, isItBundle } from 'common/utils/deviceTwinUtils';
import { deviceDisplayTypes } from 'common/utils/constants';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { BulkSoftwareDownloadModalIdCell } from '../BulkSoftwareDownloadModalIdCell';
import { BulkSoftwareDownloadModalSwCell } from '../BulkSoftwareDownloadModalSwCell';
import '../SoftwareDownloadModal.css';
import './SoftwareDownloadDeviceTable.css';

export const SoftwareDownloadDeviceTable = (props) => {
  const {
    dispatch,
    parent,
    deviceIdList,
    devicesDictionary,
    displayTextType,
    bundlesDictionary,
    localSelectedDevicesDictionary,
    filteredLocalDeviceIds,
    selectedDeviceTypes,
    hasCheckbox,
    displayMode
  } = props;
  const [sorted, setSorted] = useState([]);

  const IdCell = (row) => {
    const targetDevice = devicesDictionary?.[row.value] ? devicesDictionary?.[row.value] : bundlesDictionary?.[row.value];
    let targetDeviceDisplay = null;
    let type = null;
    const displayType = displayTextType;
    let ga2DeviceMembers = null;

    if (targetDevice != null && isGa2Device(targetDevice)) {
      ga2DeviceMembers = getGa2DeviceMembers(targetDevice);
      type = 'pivot';
      targetDeviceDisplay = toggleDisplayNameForDevices(targetDevice, displayType);
    } else if (targetDevice != null && !isItBundle(targetDevice)) {
      type = 'echo';
      targetDeviceDisplay = toggleDisplayNameForDevices(targetDevice, displayType);
    } else if (bundlesDictionary?.[row.value] != null) {
      type = 'pivot';
      targetDeviceDisplay = toggleDisplayNameForBundles(bundlesDictionary[row.value], displayType);
    }

    return (
      <BulkSoftwareDownloadModalIdCell
        displayType={displayType}
        hasCheckbox={hasCheckbox}
        type={type}
        targetDeviceId={row.value}
        bundleMembers={ga2DeviceMembers ? ga2DeviceMembers : bundlesDictionary?.[row.value]?.members}
        isChecked={localSelectedDevicesDictionary[row.value]}
        targetDeviceDisplay={targetDeviceDisplay}
        sendSelected={(selected, deviceId) => {
          let newLocalSelectedDevicesDictionary = { ...localSelectedDevicesDictionary };
          let newSelectedDeviceTypes = { ...selectedDeviceTypes };
          let bundleObj = bundlesDictionary[deviceId];

          Object.keys(newSelectedDeviceTypes).forEach((deviceType) => {
            if (bundleObj) {
              let memberIds = bundleObj.members.map((member) => member.id);
              for (let deviceId of memberIds) {
                if (newSelectedDeviceTypes[deviceType].deviceIds.hasOwnProperty(deviceId)) {
                  newSelectedDeviceTypes[deviceType].deviceIds[deviceId] = selected;
                }
              }
            } else if (newSelectedDeviceTypes[deviceType].deviceIds.hasOwnProperty(deviceId)) {
              newSelectedDeviceTypes[deviceType].deviceIds[deviceId] = selected;
            }
            newSelectedDeviceTypes[deviceType].selected = Object.keys(
              newSelectedDeviceTypes[deviceType].deviceIds
            ).every((i) => newSelectedDeviceTypes[deviceType].deviceIds[i] === true);
          });

          selected
            ? (newLocalSelectedDevicesDictionary[deviceId] = true)
            : (newLocalSelectedDevicesDictionary[deviceId] = false);

          parent.setState({
            localSelectedDevicesDictionary: newLocalSelectedDevicesDictionary,
            selectedDeviceTypes: newSelectedDeviceTypes
          });
        }}
      />
    );
  };

  let columns = [
    {
      id: 'id_col_id',
      minWidth: 265,
      resizable: true,
      Header: (row) => {
        let displayType = displayTextType;
        let deviceColHeader = 'Site/Device ID';

        switch (displayType) {
          case deviceDisplayTypes.ID:
            deviceColHeader = 'Site/Device ID';
            break;
          case deviceDisplayTypes.NAME:
            deviceColHeader = 'Site/Device Name';
            break;
        }

        let isChecked =
          filteredLocalDeviceIds &&
          filteredLocalDeviceIds.reduce((acc, curr, index) => {
            return acc && localSelectedDevicesDictionary[curr];
          }, localSelectedDevicesDictionary[filteredLocalDeviceIds[0]]);

        return (
          <div className="DeviceTable_Header_OuterDiv">
            {hasCheckbox && (
              <Checkbox
                isChecked={isChecked}
                onChange={(event) => {
                  let newLocalSelectedDevicesDictionary = {};
                  let newSelectedDeviceTypes = JSON.parse(JSON.stringify(selectedDeviceTypes));
                  let newChecked = !isChecked;

                  filteredLocalDeviceIds.forEach((fd) => {
                    newLocalSelectedDevicesDictionary[fd] = newChecked;
                  });

                  Object.keys(newSelectedDeviceTypes).forEach((deviceType) => {
                    newSelectedDeviceTypes[deviceType].selected = newChecked;
                    let deviceIds = Object.keys(newSelectedDeviceTypes[deviceType].deviceIds);
                    for (let deviceId of deviceIds) {
                      newSelectedDeviceTypes[deviceType].deviceIds[deviceId] = newChecked;
                    }
                  });

                  parent.setState({
                    localSelectedDevicesDictionary: newLocalSelectedDevicesDictionary,
                    selectedDeviceTypes: newSelectedDeviceTypes
                  });
                  event.stopPropagation(); //stop default row click stuff from happening
                }}
              />
            )}

            <div className="idNameSwitcher">
              <SvgAF
                img={displayType === deviceDisplayTypes.ID ? IconLoader.icon_toggle_id : IconLoader.icon_toggle_name}
                hover={
                  displayType === deviceDisplayTypes.ID
                    ? IconLoader.icon_toggle_id_hover
                    : IconLoader.icon_toggle_name_hover
                }
                tooltip={displayType === deviceDisplayTypes.ID ? 'Toggle to Name' : 'Toggle to ID'}
                onClick={() => {
                  dispatch(
                    setDeviceDisplayMode(
                      displayType === deviceDisplayTypes.ID ? deviceDisplayTypes.NAME : deviceDisplayTypes.ID
                    )
                  );
                }}
              />
            </div>
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={deviceColHeader}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'id_col_id')}
            />
            <div className="SoftwareDownloadTable_ResizerSliderIcon">
              <div className="SoftwareDownloadTable_ResizerSliderIcon_Bar"></div>
            </div>
          </div>
        );
      },
      className: 'BulkSoftwareDownloadModal_DeviceTable_IdColumn',
      accessor: (id) => {
        return id;
      },
      Cell: IdCell,
      sortMethod: (a, b) => {
        let objA = bundlesDictionary?.[a] ? bundlesDictionary[a] : devicesDictionary[a];
        let objB = bundlesDictionary?.[b] ? bundlesDictionary[b] : devicesDictionary[b];
        let a1 = isItBundle(objA)
          ? toggleDisplayNameForBundles(objA, displayTextType)
          : toggleDisplayNameForDevices(objA, displayTextType);
        let b1 = isItBundle(objB)
          ? toggleDisplayNameForBundles(objB, displayTextType)
          : toggleDisplayNameForDevices(objB, displayTextType);

        return a1.toLowerCase() > b1.toLowerCase() ? 1 : -1;
      }
    },
    {
      id: 'device_type',
      minWidth: 145,
      resizable: false,
      Header: (row) => {
        return (
          <div className="DeviceTable_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Type'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'device_type')}
            />
          </div>
        );
      },
      accessor: (device) => {
        let targetDevice = props?.devicesDictionary?.[device]
          ? props.devicesDictionary?.[device]
          : props.bundlesDictionary?.[device];
        let forSwUpdate = true;
        let productType = deviceToProductTypeDisplayString(targetDevice, forSwUpdate);

        return productType;
      },
      Cell: (row) => {
        return <div className="DeviceTable_cellWrapper">{row.value}</div>;
      }
    },
    {
      id: 'sw_col_id',
      minWidth: 140,
      Header: (row) => {
        return (
          <div className="DeviceTable_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'SW VERSION'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'sw_col_id')}
            />
          </div>
        );
      },
      resizable: false,
      accessor: (device) => {
        let targetDevice = props?.devicesDictionary?.[device]
          ? props?.devicesDictionary?.[device]
          : bundlesDictionary?.[device];
        return targetDevice;
      },
      Cell: (row) => {
        return (
          <div className="DeviceTable_cellWrapper">
            <BulkSoftwareDownloadModalSwCell targetDevice={row.value} />
          </div>
        );
      },
      sortMethod: (a, b) => {
        let swVersion1 = 'Unknown';
        let swVersion2 = 'Unknown';
        let device1 = a;
        let device2 = b;

        if (!isItBundle(device1)) swVersion1 = getDeviceSwVersion(device1);
        else {
          swVersion1 = getLowestSwVersion(device1);
        }
        if (!isItBundle(device2)) swVersion2 = getDeviceSwVersion(device2);
        else {
          swVersion2 = getLowestSwVersion(device2);
        }

        return swVersion1.toLowerCase() > swVersion2.toLowerCase() ? 1 : -1;
      }
    }
  ];

  const handleOnSortedChange = (newSorted) => {
    setSorted(newSorted);
  };

  let swDownloadDeviceTableDiv = document.getElementsByClassName('BulkSoftwareDownloadModal_DeviceTable')[0];
  if (swDownloadDeviceTableDiv && selectedDeviceTypes) {
    let numOfDeviceTypes = Object.keys(selectedDeviceTypes).length;
    let deviceTypesDivHeight = (24 + 12) * numOfDeviceTypes + 12;
    let searchBarDivHeight = 24 + 12 + 27;
    let tableHeight = 788 - deviceTypesDivHeight - searchBarDivHeight - 48;
    swDownloadDeviceTableDiv.style.height = `${tableHeight}px`;
  }

  let filteredLocalDeviceIdsForDetailsMode = [];
  if (displayMode === 'DETAILS') {
    filteredLocalDeviceIds.forEach((deviceId) => {
      if (localSelectedDevicesDictionary[deviceId]) {
        filteredLocalDeviceIdsForDetailsMode.push(deviceId);
      }
    });
  }

  let pageSize = displayMode !== 'DETAILS' ? deviceIdList.length : filteredLocalDeviceIdsForDetailsMode.length;

  return (
    <div className="BulkSoftwareDownloadModal_DeviceList_InnerDiv">
      <div className="BulkSoftwareDownloadModal_DeviceTable_Div">
        <ScrollReactTable
          showPagination={false}
          noDataText={''}
          className={'Global_Table BulkSoftwareDownloadModal_DeviceTable'}
          resizable={true}
          sortable={false}
          pageSize={pageSize}
          data={displayMode !== 'DETAILS' ? filteredLocalDeviceIds : filteredLocalDeviceIdsForDetailsMode}
          overlay={null}
          fetching={props.isLoaded === false}
          sorted={sorted}
          onSortedChange={(newSorted) => handleOnSortedChange(newSorted)}
          columns={columns}
        />
      </div>
    </div>
  );
};
